import * as React from 'react'

const SvgGlobeIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.75 2.5a4.375 4.375 0 110 8.75 4.375 4.375 0 010-8.75zm0-1.25a5.625 5.625 0 100 11.25 5.625 5.625 0 000-11.25zm8.75 5.625A8.7 8.7 0 0014.931.694l-.881.881A7.5 7.5 0 013.475 12.2l-.906.856a8.7 8.7 0 006.181 2.569V17.5h-2.5v1.25h6.25V17.5H10v-1.975a8.75 8.75 0 007.5-8.65z"
      fill="#163250"
    />
  </svg>
)

export default SvgGlobeIcon
